import React from 'react'

const InfoBadge = () => (
  <span className="inline-flex items-center justify-center h-4 w-4">
    <img src="/images/iicon.png" alt="Info" className="h-4 w-4 object-contain" />
  </span>
)

export default InfoBadge
